import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {WorktypesService} from "../data/worktypes.service";
import {TranslateService} from "../../../services/multilingual/translate.service";
import {TokenService} from "../../../services/auth/token.service";
import {JBMTableColumnDef} from "../../../components/JBM/JBMTable/JBMTable.component";
import {QueryHttpHelper, SearchColumnType} from "../../../components/JBM/Helpers/QueryHttpHelper";
import {Subscription} from "rxjs";
import {JBMToastsService} from "../../../components/JBM/Views/JBMToasts/JBMToasts.service";

@Component({
  selector: 'worktypes',
  templateUrl: './worktypes.component.html',
  styleUrls: ['./worktypes.component.scss']
})
export class WorktypesComponent implements OnInit, OnDestroy {
  userRights: any;
  types: any[];
  columnDefs: JBMTableColumnDef[];
  language: string=this.TokenService.getLanguage();
  loading: boolean=false;

  types$: Subscription;
  count$: Subscription;

  queryHttpHelper: QueryHttpHelper;
  searchboxVisble: boolean=true;
  search: string='';

  createActive: boolean=false;
  description: string='';
  descriptionError: string='';
  descriptionTouched: boolean=false;
  editing: boolean=false;
  unique:boolean=true;

  constructor(
      public WorktypesService: WorktypesService,
      public modalService: NgbModal,
      private TokenService: TokenService,
      private TranslateService: TranslateService,
      private JBMToastsService: JBMToastsService
  ) { }
  ngOnInit(): void {
    this.userRights = this.TokenService.getRightsByName('projects');

    this.queryHttpHelper = new QueryHttpHelper();
    this.queryHttpHelper.setSortColumn('description');
    this.queryHttpHelper.addSearchColumn('description', SearchColumnType.string);

    this.getData(true);
  }
  getData(countRows:boolean=false) {
    this.loading=true;
    let params=this.queryHttpHelper.getHttpParams(false);
    this.types$=this.WorktypesService.get(this.language, params).subscribe(
        (data: any) => this.types = data.data,()=>{},()=>{
          this.loading=false;

          // Set editmode to false for each item
          for(let type of this.types)
            type.editing=false;

          if(countRows) {
            let params=this.queryHttpHelper.getHttpParams(true);
            this.count$=this.WorktypesService.get(this.language, params).subscribe(
                (data: any) => this.queryHttpHelper.paginationProps.itemCount = data.data,()=>{},()=>{} );
          }
        } );
  }
  pageChange(page: any) {
    this.queryHttpHelper.paginationProps.page=page;
    this.getData();
  }
  sortChange(event: any) {
    this.queryHttpHelper.setSortColumn(event.name, event.descending);
    this.getData();
  }
  searchChange(event: any) {
    let value=event.value;
    let minlength=event.minlength;
    value=value.length<minlength ? '' : value;
    if(this.queryHttpHelper.getSearchValue() != value) {
      this.queryHttpHelper.setSearchValue(value);
      this.getData(true);
    }
  }
  // Create item
  startCreate() {
    if(this.editing) this.cancelEditing();
    this.clearItemData();
    this.createActive=true;
  }
  createCancel() {
    this.createActive=false;
    this.clearItemData();
  }
  // Update item
  startEditing(id: any) {
    if(!this.userRights.AllowUpdate) return false;
    if(this.createActive) this.createCancel();
    for(let type of this.types)
      if(type.id===id) {
        if(type.editing) return false;  // Row alreay in edit mode
        type.editing=true;
      } else
        type.editing=false;
    this.editing=true;
    let data=this.getOriginalValues();
    this.description=data.description;
    this.descriptionTouched=true;
    this.unique=true;
  }
  cancelEditing() {
    for(let type of this.types)
      type.editing=false;
    this.editing=false;
    this.clearItemData();
    this.getData(false);
  }
  onChangeDescription() {
    this.descriptionTouched=true;
  }
  validateDescription() {
    let value=this.description.trim();
    if(!value) this.descriptionError=this.TranslateService.GetTranslation('entity.requiredfield');
    return value!='';
  }
  // Save item data
  createItem() {
    this.getValues();
    let data=this.setItemData(0);
    delete data.id; // Send data without id
    this.WorktypesService.create(data).subscribe(()=>{},
       (error: any) => { this.handleError(error) },() => { this.afterSave() })
  }
  updateItem() {
    this.getValues();
    let originalValues=this.getOriginalValues();
    if(originalValues.description==this.description) {
      // Nothing changed; pretend if it has been a successful update
      this.showToast();
      this.cancelEditing();
      return false;
    }
    let data=this.setItemData(originalValues.id);
    this.WorktypesService.update(data).subscribe(
        ()=>{},(error: any) => { this.handleError(error) },
        () => { this.afterSave() })
  }
  getValues() {
    this.description=this.description.trim();
  }
  getOriginalValues() {
    for(let type of this.types)
      if(type.editing)
        return type;
    return null;
  }
  setItemData(id: any) {
    return { id: id, language: this.language, description: this.description }
  }
  clearItemData() {
    this.description='';
    this.descriptionTouched=false;
  }
  handleError(error: any) {
    this.unique=true;
    if(error=='not_unique') {
      this.unique=false;
      this.descriptionError=this.TranslateService.GetTranslation('entity.description-not-unique');
    }
  }
  afterSave() {
    this.showToast();
    if(this.createActive) {
      this.createCancel();
      this.getData(true);
    }
    if(this.editing) this.cancelEditing();
  }
  showToast() {
    this.JBMToastsService.success( this.TranslateService.GetTranslation('ui.entity-saved'));
  }
  ngOnDestroy() {
    // Clean up observable subscriptions to avoid memory leaks
    if(this.types$!=undefined) this.types$.unsubscribe();
    if(this.count$!=undefined) this.count$.unsubscribe();
  }
}
